var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10V3.5L16 3",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C12.3284 12 13 11.3284 13 10.5C13 9.67157 12.3284 9 11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12Z",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#067BF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.456 22L4.568 15.52H6.104L6.816 19.288L7.584 15.52H9.064L9.176 22H8.16L8.04 17.688L7.288 22H6.384L5.584 17.656L5.488 22H4.456ZM10.5928 22V15.52H12.7688C13.1581 15.52 13.4781 15.5947 13.7288 15.744C13.9795 15.888 14.1661 16.1013 14.2888 16.384C14.4115 16.6613 14.4728 17 14.4728 17.4C14.4728 17.9013 14.3901 18.2853 14.2248 18.552C14.0595 18.8133 13.8355 18.9947 13.5528 19.096C13.2701 19.1973 12.9528 19.248 12.6008 19.248H12.0248V22H10.5928ZM12.0248 18.248H12.5048C12.6808 18.248 12.8141 18.216 12.9048 18.152C12.9955 18.088 13.0541 17.992 13.0808 17.864C13.1128 17.736 13.1288 17.5733 13.1288 17.376C13.1288 17.2107 13.1155 17.0667 13.0888 16.944C13.0675 16.816 13.0115 16.7147 12.9208 16.64C12.8301 16.5653 12.6888 16.528 12.4968 16.528H12.0248V18.248ZM15.4911 22V21.056L17.0431 18.672C17.1605 18.496 17.2698 18.3253 17.3711 18.16C17.4778 17.9947 17.5631 17.8267 17.6271 17.656C17.6965 17.4853 17.7311 17.3067 17.7311 17.12C17.7311 16.9333 17.6938 16.7947 17.6191 16.704C17.5445 16.6133 17.4431 16.568 17.3151 16.568C17.1711 16.568 17.0591 16.608 16.9791 16.688C16.8991 16.768 16.8431 16.8747 16.8111 17.008C16.7845 17.1413 16.7711 17.2907 16.7711 17.456V17.776H15.4751V17.432C15.4751 17.048 15.5365 16.7067 15.6591 16.408C15.7818 16.104 15.9765 15.8667 16.2431 15.696C16.5098 15.52 16.8591 15.432 17.2911 15.432C17.8725 15.432 18.3098 15.584 18.6031 15.888C18.9018 16.1867 19.0511 16.6053 19.0511 17.144C19.0511 17.4053 19.0085 17.648 18.9231 17.872C18.8431 18.096 18.7338 18.3147 18.5951 18.528C18.4618 18.736 18.3178 18.9547 18.1631 19.184L16.9791 20.952H18.8751V22H15.4911Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp2);
export default __webpack_public_path__ + "static/media/mp2.42eeb3e25751b1d760dbd1509d9719ce.svg";
export { ForwardRef as ReactComponent };